import { render } from "./wind.vue?vue&type=template&id=77c498ec"
import script from "./wind.vue?vue&type=script&lang=js"
export * from "./wind.vue?vue&type=script&lang=js"

import "./wind.vue?vue&type=style&index=0&id=77c498ec&lang=css"

import exportComponent from "C:\\GIT_REPOS\\pilot-tools\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__